import React from 'react';
import PropTypes from 'prop-types';

import {getGsheetURL} from './URL';

// import Loading from '../loading';

import style from './style.css';

// function fixGsheetScroll() {
//   let previewsY = null;
//   let listenerAttached = false;
//   function fixScroll() {
//     const activeElement = document.activeElement;
//     listenerAttached = true;
//     if (activeElement.tagName === 'IFRAME' && previewsY !== null) {
//       window.scrollTo(0, previewsY);
//       previewsY = null;
//     } else {
//       previewsY = window.scrollY;
//     }
//   }
//   if (!listenerAttached) {
//     document.addEventListener('scroll', fixScroll);
//   }
// }

export default class GTable extends React.Component {

  static propTypes = {
    spreadsheet_id: PropTypes.string.isRequired,
    sheet_id: PropTypes.number.isRequired,
    isLoading: PropTypes.bool.isRequired,
    // num_rows: PropTypes.number.isRequired,
  };

  static defaultProps = {
    isLoading: false,
    // num_rows: 100,
  };

  constructor() {
    super(...arguments);
    this.state = {
      windowHandler: null,
      windowInit: false
    };
  }

  // componentDidMount() {
  //   fixGsheetScroll();
  // }

  componentWillUnmount() {
    this.closeWindow(this.state.windowHandler)();
  }

  get gsheetURL() {
    const {spreadsheet_id, sheet_id} = this.props;
    return getGsheetURL(spreadsheet_id, sheet_id);
  }

  createNewWindow() {
    var windowHandler = this.state.windowHandler;
    if (!this.state.windowInit) {
      windowHandler = window.open(
        this.gsheetURL,
        'mangabey',
        'width=1000px,height=1000px');
      this.setState({
        windowInit: true,
        windowHandler: windowHandler
      });
    } else {
      this.state.windowHandler.location.href = this.gsheetURL;
    }

    window.addEventListener('beforeunload',
      this.closeWindow(windowHandler)
    );
  }

  createIframeTable () {
    const {isLoading} = this.props;
    const iframeClass = isLoading? style['iframe-hidden']: style['gsheet'];
    // const height = (this.props.num_rows - 1) * 24 + 300;
    return (
      <React.Fragment>
        {isLoading? <Loading /> : null}
        <iframe
         className={iframeClass}
         src={this.gsheetURL}
         width="100%"
         height={`1000px`}
        />
      </React.Fragment>
    );
  }

  closeWindow(windowHandler) {
    return () => {
      if (!windowHandler) {
        return;
      }
      if (!windowHandler.closed) {
        windowHandler.close();
      }
      windowHandler = null;
    };
  }

  render() {
    const {isLoading, spreadsheet_id} = this.props;

    if (isLoading) {
      return (<div></div>);
    }

    if (!spreadsheet_id) {
      return (<div></div>);
    }

    this.createNewWindow();

    return (<div></div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/gsheet/gtable.js